import { render, staticRenderFns } from "./legal-entity-details.container.vue?vue&type=template&id=226760b3&scoped=true&lang=pug"
import script from "./legal-entity-details.container.vue?vue&type=script&lang=ts"
export * from "./legal-entity-details.container.vue?vue&type=script&lang=ts"
import style0 from "./legal-entity-details.container.vue?vue&type=style&index=0&id=226760b3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "226760b3",
  null
  
)

export default component.exports